import React, { HTMLProps } from "react";

import "./logo.css";

export const Logo = ({
	html,
	...divProps
}: HTMLProps<HTMLDivElement> & {
	html: string;
}) => <div className="logo" {...divProps} dangerouslySetInnerHTML={{ __html: html }} />;
Logo.displayName = "Logo";
